import React, { forwardRef, } from 'react';
import { Box } from '../Box';
import { Field } from '../fields/Field';
import { Input, StyledFrontIcon, StyledTrailingIcon, } from '../fields/components/CommonInput';
import { useUniqueId } from '../utils/id';
/**
 * A reusable TextInput component that supports various input types, custom styling, icons,
 * and autofill detection.
 *
 * ### Caveats:
 * - `onAutoFill` triggers after animation end (animation duration is 2s),
 * the animation starts when a user selects or hovers over an autofill option
 */
export const TextInput = forwardRef(function TextInput({ id: idProp, type = 'text', placeholder, name, value, error = false, onBlur, onChange, onInputChange, onAutoFill, disabled = false, frontIcon, trailingIcon, fallbackStyle, autoCompleteAttr = 'off', inputModeAttr, ...fieldProps }, ref) {
    const id = useUniqueId(idProp);
    const handleAnimationEnd = (e) => {
        if (e.animationName === 'onAutoFillStart' && onAutoFill && !!value) {
            onAutoFill();
        }
    };
    return (React.createElement(Field, { ...fieldProps, htmlFor: id, error: error },
        React.createElement(Box, { flex: true, alignItems: "center", justifyContent: "flex-start" },
            frontIcon && (React.createElement(StyledFrontIcon, { "$disabled": disabled, render: frontIcon, color: "sesame" })),
            React.createElement(Input, { disabled: disabled, type: type, id: id, name: name, ref: ref, onAnimationEnd: handleAnimationEnd, placeholder: placeholder, value: value, "$error": error, "$frontIcon": frontIcon, "$fallbackStyle": fallbackStyle, autoComplete: autoCompleteAttr, onChange: (e) => {
                    onChange && onChange(e.currentTarget.value);
                    onInputChange && onInputChange(e);
                }, onBlur: onBlur, inputMode: inputModeAttr }),
            trailingIcon && (React.createElement(StyledTrailingIcon, { "$disabled": disabled, render: trailingIcon, color: "sesame" })))));
});
//# sourceMappingURL=TextInput.js.map